import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function LegacyMusicalRedirect({ language }: { language?: string }) {
  const { storyName, storyId } = useParams();
  const { search, hash, state } = useLocation();
  const prefix = language ? `/${language}` : '';
  const parts = [storyName, storyId].filter((part): part is string => Boolean(part));
  const pathname = `${prefix}/musicals/${parts.map(encodeURIComponent).join('/')}`;
  return <Navigate to={{ pathname, search, hash }} state={state} replace />;
}
